var map = {
	"./gallery_00.jpg": 1821,
	"./gallery_01.jpg": 1822,
	"./gallery_02.jpg": 1823,
	"./gallery_03.jpg": 1824,
	"./gallery_04.jpg": 1825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1820;